import { Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { type Filters } from '../DateAndTime.helpers';
import DayFilters from '../DayFilters';
export default function FilterDialog({
  openFilterDialog,
  setOpenFilterDialog,
  setFilters,
  filters,
  setThreeDaySwitch,
  threeDaySwitch,
  setTimeOfDay,
  setWeekDays,
  weekDays,
  timeOfDay
}: Readonly<{
  openFilterDialog: boolean;
  setOpenFilterDialog: (openFilterDialog: boolean) => void;
  setFilters: ({
    timeOfDay,
    weekDays
  }: Filters) => void;
  filters: Filters;
  setThreeDaySwitch: (bool: boolean) => void;
  threeDaySwitch: boolean;
  setTimeOfDay: (timeOfDay: string) => void;
  setWeekDays: (weekDays: string[]) => void;
  weekDays: string[];
  timeOfDay: string;
}>) {
  const {
    t
  } = useTranslation('dateAndTime');
  return <Dialog open={openFilterDialog} onClose={() => {
    setOpenFilterDialog(false);
    setTimeOfDay(filters.timeOfDay ?? '');
    setWeekDays(filters.weekDays ?? []);
  }} aria-labelledby="alert-dialog-title" data-sentry-element="Dialog" data-sentry-component="FilterDialog" data-sentry-source-file="FilterDialog.tsx">
			<DialogContent data-sentry-element="DialogContent" data-sentry-source-file="FilterDialog.tsx">
				<DayFilters threeDaySwitch={threeDaySwitch} timeOfDay={timeOfDay} setTimeOfDay={setTimeOfDay} weekDays={weekDays} setWeekDays={setWeekDays} data-sentry-element="DayFilters" data-sentry-source-file="FilterDialog.tsx" />
			</DialogContent>
			<DialogActions sx={{
      backgroundColor: 'backgrounds.neutral'
    }} data-sentry-element="DialogActions" data-sentry-source-file="FilterDialog.tsx">
				<Button onClick={() => {
        setOpenFilterDialog(false);
        setTimeOfDay(filters.timeOfDay ?? '');
        setWeekDays(filters.weekDays ?? []);
      }} sx={{
        textTransform: 'none'
      }} data-sentry-element="Button" data-sentry-source-file="FilterDialog.tsx">
					<Typography color="primary.main" variant="buttonLabel" data-sentry-element="Typography" data-sentry-source-file="FilterDialog.tsx">
						{t('cancel')}
					</Typography>
				</Button>
				<Button onClick={() => {
        setFilters({
          weekDays,
          timeOfDay
        });
        setOpenFilterDialog(false);
        setThreeDaySwitch(false);
      }} sx={{
        textTransform: 'none'
      }} data-test-id="button_apply_filter" data-sentry-element="Button" data-sentry-source-file="FilterDialog.tsx">
					<Typography color="secondary.main" variant="buttonLabel" data-sentry-element="Typography" data-sentry-source-file="FilterDialog.tsx">
						{t('apply')}
					</Typography>
				</Button>
			</DialogActions>
		</Dialog>;
}